import BaseService from '_services/rest/base';

class SampleService extends BaseService {
  constructor() {
    super();
  }

  deleteFile(id) {
    return this.request(`${this.getUrl()}/file/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  deleteSample(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'DELETE')
      .catch(err => {
        throw err;
      });
  }

  getUrl() {
    return `${super.getUrl()}api/sample`;
  }

  getList(params) {
    const filters = {
      search: params.search,
      type_id: params.type_id,
      quotation_id: params.quotation_id,
      sort: params.sort,
    };

    return this.request(`${this.getUrl()}/all/${params.skip}/${params.take}`, filters)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  getSampleById(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

  print(id) {
    return this.request(`${super.getUrl()}api/pdf/sample/${id}`, null, 'GET', 'arraybuffer')
      .catch(err => {
        throw err;
      });
  }

  save(sample) {
    let formData = new FormData();
    formData = this.setFormData(sample, formData);
    return this.request(`${this.getUrl()}/${sample.id}`, formData, 'post')
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }
}

export default new SampleService();
